import { Map, List } from 'immutable';
import { without } from '../helpers/Immutable';

import { ActionTypes } from '../constants/AppConstants';
import BaseStore from './BaseStore';

import StoredPaymentCard from '../records/customer/StoredPaymentCard';

class PaymentCardStore extends BaseStore {

    getInitialState () {
        return new Map({
            cards: new List(),
            braintreeCards: new List(),
        });
    }

    getKeyGoCard () {
        const cards = this.state.get('cards');
        return cards.find((card) => card.isKeyGoCard && card.cardToken) || new StoredPaymentCard();
    }

    hasCards () {
        return !this.state.get('cards').isEmpty();
    }

    handleCardsLoaded ({ cards }) {
        this.setState(this.state.set('cards', cards));
    }

    handleCardDeleted ({ deleted }) {
        const cards = without(this.state.get('cards'), deleted);
        this.setState(this.state.set('cards', cards));
    }

    handleBraintreeCardsLoaded ({ cards }) {
        this.setState(this.state.set('braintreeCards', cards));
    }

    handleBraintreeCardDeleted ({ deleted }) {
        const cards = without(this.state.get('braintreeCards'), deleted);
        this.setState(this.state.set('braintreeCards', cards));
    }

    getActionHandlers () {
        return {
            [ ActionTypes.CUSTOMER_PAYMENTCARDS_LOADED ]: this.handleCardsLoaded,
            [ ActionTypes.CUSTOMER_PAYMENTCARD_DELETED ]: this.handleCardDeleted,
            [ ActionTypes.CUSTOMER_BRAINTREE_PAYMENTCARDS_LOADED ]: this.handleBraintreeCardsLoaded,
            [ ActionTypes.CUSTOMER_BRAINTREE_PAYMENTCARD_DELETED ]: this.handleBraintreeCardDeleted,
            [ ActionTypes.LOGGED_OUT ]: this.resetState
        };
    }

}

export default new PaymentCardStore();
